/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  IsWaterfallHybrid
} from '../../model/isWaterfallHybrid'
import type {
  WaterfallConfigData
} from '../../model/waterfallConfigData'
import type {
  WaterfallConfigRetrieveParams
} from '../../model/waterfallConfigRetrieveParams'
import type {
  WaterfallConfigTableRetrieveParams
} from '../../model/waterfallConfigTableRetrieveParams'
import type {
  WaterfallConfigUpsertDataRequest
} from '../../model/waterfallConfigUpsertDataRequest'
import type {
  WaterfallTierMappingData
} from '../../model/waterfallTierMappingData'
import type {
  WaterfallTierMappingDataList
} from '../../model/waterfallTierMappingDataList'
import type {
  WaterfallTierMappingUpsertDataListRequest
} from '../../model/waterfallTierMappingUpsertDataListRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a waterfall config summary table
 */
export const waterfallConfigTableRetrieve = (
    fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/waterfall/config-table/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallConfigTableRetrieveQueryKey = (fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/waterfall/config-table/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallConfigTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallConfigTableRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>> = ({ signal }) => waterfallConfigTableRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallConfigTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>>
export type WaterfallConfigTableRetrieveQueryError = unknown

export const useWaterfallConfigTableRetrieve = <TData = Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallConfigTableRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallConfigTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallConfigTableRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>> = ({ signal }) => waterfallConfigTableRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallConfigTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>>
export type WaterfallConfigTableRetrieveSuspenseQueryError = unknown

export const useWaterfallConfigTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: WaterfallConfigTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallConfigTableRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallConfigTableRetrieveLoader = (queryParamsOrFn?: (WaterfallConfigTableRetrieveParams | ((params: Params) => WaterfallConfigTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallConfigTableRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => waterfallConfigTableRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get a waterfall config
 */
export const waterfallConfigRetrieve = (
    fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallConfigData>(
      {url: `/fund-family/${fundFamilyId}/waterfall/configuration/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallConfigRetrieveQueryKey = (fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/waterfall/configuration/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallConfigRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallConfigRetrieve>>> = ({ signal }) => waterfallConfigRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallConfigRetrieve>>>
export type WaterfallConfigRetrieveQueryError = unknown

export const useWaterfallConfigRetrieve = <TData = Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallConfigRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallConfigRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallConfigRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallConfigRetrieve>>> = ({ signal }) => waterfallConfigRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallConfigRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallConfigRetrieve>>>
export type WaterfallConfigRetrieveSuspenseQueryError = unknown

export const useWaterfallConfigRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: WaterfallConfigRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallConfigRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallConfigRetrieveLoader = (queryParamsOrFn?: (WaterfallConfigRetrieveParams | ((params: Params) => WaterfallConfigRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallConfigRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => waterfallConfigRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upsert a waterfall config
 */
export const waterfallConfigUpsert = (
    fundFamilyId: string,
    waterfallConfigUpsertDataRequest: WaterfallConfigUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallConfigData>(
      {url: `/fund-family/${fundFamilyId}/waterfall/configuration/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: waterfallConfigUpsertDataRequest
    },
      options);
    }
  


export const getWaterfallConfigUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallConfigUpsert>>, TError,{fundFamilyId: string;data: WaterfallConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallConfigUpsert>>, TError,{fundFamilyId: string;data: WaterfallConfigUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallConfigUpsert>>, {fundFamilyId: string;data: WaterfallConfigUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  waterfallConfigUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallConfigUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallConfigUpsert>>>
    export type WaterfallConfigUpsertMutationBody = WaterfallConfigUpsertDataRequest
    export type WaterfallConfigUpsertMutationError = unknown

    export const useWaterfallConfigUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallConfigUpsert>>, TError,{fundFamilyId: string;data: WaterfallConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallConfigUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a waterfall config
 */
export const isWaterfallHybridRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<IsWaterfallHybrid>(
      {url: `/fund-family/${fundFamilyId}/waterfall/is-hybrid/`, method: 'GET', signal
    },
      options);
    }
  

export const getIsWaterfallHybridRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/waterfall/is-hybrid/`] as const;
    }

    
export const getIsWaterfallHybridRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIsWaterfallHybridRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>> = ({ signal }) => isWaterfallHybridRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IsWaterfallHybridRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>>
export type IsWaterfallHybridRetrieveQueryError = unknown

export const useIsWaterfallHybridRetrieve = <TData = Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIsWaterfallHybridRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getIsWaterfallHybridRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIsWaterfallHybridRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>> = ({ signal }) => isWaterfallHybridRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IsWaterfallHybridRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>>
export type IsWaterfallHybridRetrieveSuspenseQueryError = unknown

export const useIsWaterfallHybridRetrieveSuspense = <TData = Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isWaterfallHybridRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIsWaterfallHybridRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getIsWaterfallHybridRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getIsWaterfallHybridRetrieveQueryKey(fundFamilyId),
              queryFn: () => isWaterfallHybridRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns a list of waterfall tier mappings for a waterfall
 */
export const waterfallTierMappingsList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallTierMappingDataList>(
      {url: `/fund-family/${fundFamilyId}/waterfall/waterfall-tier-mappings/`, method: 'GET', signal
    },
      options);
    }
  

export const getWaterfallTierMappingsListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/waterfall/waterfall-tier-mappings/`] as const;
    }

    
export const getWaterfallTierMappingsListQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTierMappingsListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTierMappingsList>>> = ({ signal }) => waterfallTierMappingsList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTierMappingsListQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTierMappingsList>>>
export type WaterfallTierMappingsListQueryError = unknown

export const useWaterfallTierMappingsList = <TData = Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTierMappingsListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallTierMappingsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTierMappingsListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTierMappingsList>>> = ({ signal }) => waterfallTierMappingsList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTierMappingsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTierMappingsList>>>
export type WaterfallTierMappingsListSuspenseQueryError = unknown

export const useWaterfallTierMappingsListSuspense = <TData = Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTierMappingsListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallTierMappingsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallTierMappingsListQueryKey(fundFamilyId),
              queryFn: () => waterfallTierMappingsList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts a list of waterfall tier mappings for a waterfall
 */
export const waterfallTierMappingsUpsert = (
    fundFamilyId: string,
    waterfallTierMappingUpsertDataListRequest: WaterfallTierMappingUpsertDataListRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallTierMappingDataList>(
      {url: `/fund-family/${fundFamilyId}/waterfall/waterfall-tier-mappings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: waterfallTierMappingUpsertDataListRequest
    },
      options);
    }
  


export const getWaterfallTierMappingsUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallTierMappingsUpsert>>, TError,{fundFamilyId: string;data: WaterfallTierMappingUpsertDataListRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallTierMappingsUpsert>>, TError,{fundFamilyId: string;data: WaterfallTierMappingUpsertDataListRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallTierMappingsUpsert>>, {fundFamilyId: string;data: WaterfallTierMappingUpsertDataListRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  waterfallTierMappingsUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallTierMappingsUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallTierMappingsUpsert>>>
    export type WaterfallTierMappingsUpsertMutationBody = WaterfallTierMappingUpsertDataListRequest
    export type WaterfallTierMappingsUpsertMutationError = unknown

    export const useWaterfallTierMappingsUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallTierMappingsUpsert>>, TError,{fundFamilyId: string;data: WaterfallTierMappingUpsertDataListRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallTierMappingsUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns the data for a waterfall tier mapping
 */
export const waterfallTierMappingsRetrieve = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallTierMappingData>(
      {url: `/fund-family/${fundFamilyId}/waterfall/waterfall-tier-mappings/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getWaterfallTierMappingsRetrieveQueryKey = (fundFamilyId: string,
    id: string,) => {
    return [`/fund-family/${fundFamilyId}/waterfall/waterfall-tier-mappings/${id}/`] as const;
    }

    
export const getWaterfallTierMappingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTierMappingsRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>> = ({ signal }) => waterfallTierMappingsRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTierMappingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>>
export type WaterfallTierMappingsRetrieveQueryError = unknown

export const useWaterfallTierMappingsRetrieve = <TData = Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTierMappingsRetrieveQueryOptions(fundFamilyId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallTierMappingsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTierMappingsRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>> = ({ signal }) => waterfallTierMappingsRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTierMappingsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>>
export type WaterfallTierMappingsRetrieveSuspenseQueryError = unknown

export const useWaterfallTierMappingsRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTierMappingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTierMappingsRetrieveSuspenseQueryOptions(fundFamilyId,id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallTierMappingsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && id) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallTierMappingsRetrieveQueryKey(fundFamilyId,id),
              queryFn: () => waterfallTierMappingsRetrieve(fundFamilyId,id),
            }).then(() => null);
          }
          return null;
        });
      